import React from 'react';
import { TranscriptDetail } from './types';

interface TranscriptViewModalProps {
  transcript: TranscriptDetail | null;
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
}

const TranscriptViewModal: React.FC<TranscriptViewModalProps> = ({ 
  transcript, 
  isOpen, 
  isLoading, 
  onClose 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-xl font-semibold text-gray-900">Transcript Details</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 text-2xl"
            >
              ×
            </button>
          </div>

          {isLoading ? (
            <div className="text-center py-12">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <p className="text-gray-600">Loading transcript...</p>
            </div>
          ) : transcript ? (
            <div className="space-y-6">
              {/* Transcript Header */}
              <div className="border-b border-gray-200 pb-4">
                <h4 className="text-lg font-semibold text-gray-900">{transcript.title}</h4>
              </div>

              {/* Attached Clients */}
              {transcript.clients && transcript.clients.length > 0 && (
                <div>
                  <h5 className="text-md font-semibold text-gray-900 mb-3">Attached Clients</h5>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {transcript.clients.map((client) => (
                      <div key={client.id} className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                        <div className="font-medium text-blue-900">{client.name}</div>
                        <div className="text-sm text-blue-700">{client.email}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Transcript Content */}
              <div>
                <h5 className="text-md font-semibold text-gray-900 mb-3">Transcript Content</h5>
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 max-h-96 overflow-y-auto">
                  <div className="whitespace-pre-wrap text-sm text-gray-700 leading-relaxed">
                    {transcript.content}
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center py-12 text-gray-500">
              <p>Failed to load transcript details</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TranscriptViewModal; 